import { Box, Text } from "@chakra-ui/react"
import { BlockHeroEntityHydrated } from "@jackfruit/common"
import React from "react"
import HeroImageWarmup from "./components/HeroImageWarmup"
import HeroBlockTemplate1 from "./templates/HeroBlockTemplate1"
import HeroBlockTemplate2 from "./templates/HeroBlockTemplate2"

interface Props {
  config: BlockHeroEntityHydrated
}

const HeroBlock: React.FC<Props> = ({ config }) => {
  const { template } = config

  let component = null

  switch (template) {
    case "template1":
      component = <HeroBlockTemplate1 config={config} />
      break
    case "template2":
      component = <HeroBlockTemplate2 config={config} />
      break
    default:
      component = (
        <Box>
          <Text>Template [{template}] not implemented</Text>
        </Box>
      )
  }

  return (
    <div className="hero-block">
      <style>
        {`
        .hero-block a {
          color: var(--chakra-colors-primary-500);
        }
        `}
      </style>
      <HeroImageWarmup config={config} />
      {component}
    </div>
  )
}

export default HeroBlock
